import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { SoItemDetailsBySoIdDTO } from './dto/so-item-details-by-so-id.dto';


export class SaleOrderItemsBySoIdReaponseModel extends GlobalResponseObject {
    data?: SoItemDetailsBySoIdDTO;

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data /SaleOrderItemsDto[]
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: SoItemDetailsBySoIdDTO) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}

 